import { DialogContent, Divider, dividerClasses, IconButton, styled } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export const StyledDivider = styled(Divider)({
  flex: "none",
  [`& .${dividerClasses.wrapperVertical}`]: {
    paddingInline: "0",
  },
});

export const DialogHeader = styled((props: JSX.IntrinsicElements["div"] & { onClose?: () => void }) => {
  const { onClose, children, ...rest } = props;
  return (
    <div {...rest}>
      <div>{children}</div>
      <IconButton variant="contained" color={"secondary"} size={"tiny"} onClick={onClose}>
        <CloseRoundedIcon />
      </IconButton>
    </div>
  );
})({
  display: "grid",
  gridTemplateColumns: "1fr auto",
  alignItems: "center",
  padding: "24px 24px 0 24px",
  marginBottom: "-8px",
});

export const DrawerContent = styled(DialogContent)({
  padding: "16px",
});

export const DrawerHeader = styled((props: JSX.IntrinsicElements["div"] & { onClose?: () => void }) => {
  const { onClose, children, ...rest } = props;
  return (
    <div {...rest}>
      <div>{children}</div>
      <IconButton variant="contained" color={"secondary"} size={"medium"} onClick={onClose}>
        <CloseRoundedIcon />
      </IconButton>
    </div>
  );
})({
  padding: "16px 16px 0 16px",
  marginBottom: "8px",
  display: "grid",
  gridTemplateColumns: "1fr auto",
  alignItems: "center",
  ["& .MuiIconButton-sizeMedium"]: {
    margin: "4px",
  },
});
